// extracted by mini-css-extract-plugin
export default {"root":"gH6ge"};